import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { buildStyleProps } from './styleProps.utils.js';
const withStyleProps = Component => {
  return forwardRef(function ReactBase_withStylePropsHoc(props, ref) {
    const styleAndComponentProps = buildStyleProps(props);
    return jsx(Component, Object.assign({
      as: props.as
    }, styleAndComponentProps, {
      ref: ref
    }), void 0);
  });
};
export { withStyleProps };